/**
 * Cuántos artículos y cuántas unidades lleva una venta (Martin, 5 oct 2026:
 * "que el vendedor vaya sabiendo"). Cuenta MERCADERÍA: el envío (ENV0000) y
 * los renglones negativos (canjes de gift card) no son productos que se
 * entregan. Un mismo artículo en dos renglones (cobradas + bonificada) es UN
 * artículo y suma sus unidades. Única regla: la usan los dos forms de NV.
 */
export function conteoItems(items) {
  const articulos = new Set()
  let unidades = 0
  for (const it of items || []) {
    const cod = String(it.articulo?.codigo_alfa || '').toUpperCase()
    if (cod === 'ENV0000' || (parseFloat(it.precio_lista) || 0) < 0) continue
    const cant = parseInt(it.cantidad) || 0
    if (cant <= 0) continue
    articulos.add(it.articulo?.id ?? it.articulo_id ?? cod)
    unidades += cant
  }
  return { articulos: articulos.size, unidades }
}

export const textoConteo = ({ articulos, unidades }) =>
  `${articulos} ${articulos === 1 ? 'artículo' : 'artículos'} · ${unidades} ${unidades === 1 ? 'unidad' : 'unidades'}`
